import React, { useContext, useState } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { Field } from 'formik';
import { FormServiceContext } from 'app/utils/contexts';
import helpers from 'app/utils/helpers';

const Successor = (props) => {
    const { classes, errors, values, handleChange } = props;
    const { canEdit } = useContext(FormServiceContext);

    const [doc, setDoc] = useState(values.deCpfCnpjSucessor);

    const handleChangeDocumente = (e) => {
        const value = e.target.value;
        setDoc(helpers.formatarDocumento(value));
    };

    const validateDocument = (value) => {
        let error;
        if (!helpers.validateCpfCnpj(value)) {
            error = 'Documento inválido';
        }
        return error;
    };

    const validateRequired = (value) => {
        let error;
        if (!value || value === '') {
            error = 'Campo obrigatório';
        }
        return error;
    };

    return (
        <Grid item container xs={12} spacing={3}>
            <Grid item xs={12}>
                <h3 className={classes.titleTable}>Sucessor(a):</h3>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Field
                    as={TextField}
                    name="deCpfCnpjSucessor"
                    label="CNPJ / CPF Sucessora"
                    margin="dense"
                    variant="filled"
                    value={doc}
                    disabled={!canEdit}
                    fullWidth
                    onChange={(e) => {
                        handleChange(e);
                        handleChangeDocumente(e);
                    }}
                    inputProps={{
                        maxLength: 18,
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={Boolean(errors.deCpfCnpjSucessor)}
                    helperText={errors.deCpfCnpjSucessor || ''}
                    validate={validateDocument}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Field
                    as={TextField}
                    name="nmCompletoSucessor"
                    label="Nome / Razão social Sucessora"
                    margin="dense"
                    variant="filled"
                    disabled={!canEdit}
                    fullWidth
                    error={Boolean(errors.nmCompletoSucessor)}
                    helperText={errors.nmCompletoSucessor || ''}
                    inputProps={{
                        maxLength: 100,
                    }}
                    validate={validateRequired}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default Successor;
